export enum DaysOffEnum {
  FullDay = 1,
  HalfDay = 2,
}

export enum VacationStatusEnum {
  Requested = 1,
  Approved = 2,
  Cancelled = 3,
}

export enum LeaveTypeEnum {
  PTO = 1,
  ESTA = 2,
}

export enum StaffCategoryEnum {
  LoggedIn = 1,
  Supervisor = 2,
  Junior = 3,
}
export const daysOffMap: Record<number, string> = {
  [DaysOffEnum.FullDay]: 'FullDay',
  [DaysOffEnum.HalfDay]: 'HalfDay',
};

export const vacationStatusMap: Record<number, string> = {
  [VacationStatusEnum.Requested]: 'Requested',
  [VacationStatusEnum.Approved]: 'Approved',
  [VacationStatusEnum.Cancelled]: 'Cancelled',
};

export const leaveTypeMap: Record<number, string> = {
  [LeaveTypeEnum.PTO]: 'PTO',
  [LeaveTypeEnum.ESTA]: 'ESTA',
};

export const staffCategoryMap: Record<number, string> = {
  [StaffCategoryEnum.LoggedIn]: 'Requested',
  [StaffCategoryEnum.Supervisor]: 'Approved',
  [StaffCategoryEnum.Junior]: 'Cancelled',
};
